import React from "react";
import { useNavigate, useLocation } from "react-router";

import fileRequest from "../../Asset/Images/file-request.png";
import homeIcon from "../../Asset/Images/home-icon.png";
import "./style.css";



const MobileFooter = () => {
    const location = useLocation()
    let navigate = useNavigate();

    return(
        <>
            <div className="footer-mobile-wgts d-md-none">
                <div className="wap-mb--ftr">
                    <ul className="ftr-listwap-bottom d-flex align-items-center p-0 m-0">
                        <li className={location.pathname.includes('dashboard') ? 'active' : ''}><span onClick={() => navigate('/dashboard')} className="list-menu-btm"><img src={homeIcon} alt="" /></span><span className="text-head-ftr">Dashboard</span></li>
                        <li className={location.pathname.includes('template') ? 'active' : ''} ><span onClick={() => navigate('/template/deploy')} className="list-menu-btm"><img src={fileRequest} alt="" /></span><span className="text-head-ftr">New Request</span></li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default MobileFooter;